import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const withdrawalHistorySchema = z.object({
  /** Binance における出金 ID */
  id: z.string(),
  /** 出金額 */
  amount: decimalSchema,
  /** 出金時の手数料 */
  transactionFee: decimalSchema,
  /** アセット名（例：USDT, BTC） */
  coin: z.string(),
  /** ステータスコード（例：6 は成功） */
  status: z.number(),
  /** 出金先アドレス */
  address: z.string(),
  /** ブロックチェーン上のトランザクション ID */
  txId: z.string().optional(),
  /** 出金申請日時（UTC） */
  applyTime: z
    .string()
    .transform((v) => new Date(`${v.split(' ').join('T')}Z`).getTime()),
  /** 使用されたネットワーク（例：ETH, BTC） */
  network: z.string(),
  /** 転送タイプ（0: 外部転送, 1: 内部転送） */
  transferType: z.number(),
  /** 出金注文 ID（存在しない場合は返却されない） */
  withdrawOrderId: z.string().optional(),
  /** 出金エラーの理由（失敗時のみ） */
  info: z.string().optional(),
  /** コンファーム数 */
  confirmNo: z.number().optional(),
  /** ウォレットタイプ（0: 現物, 1: 資金） */
  walletType: z.number(),
  /** 取引キー（空の場合もあり） */
  txKey: z.string().optional(),
  /** 出金完了日時（UTC、status = 6 の場合のみ） */
  completeTime: z.string().optional(),
})

export const responseSchema = z.array(withdrawalHistorySchema)
